import api from 'Application/api/api';

const getEmployees = (load, cancelToken = null) =>
    api.get('/employees', {
        params: {
            load,
        },
        cancelToken,
    });

export default getEmployees;
